import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSub = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 13,
	viewBox: "0 0 48 13",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 13,
				fill: "#B6B6B6",
				rx: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0CA10F",
				d: "M3,1 L24,1 L24,1 L24,12 L3,12 C1.8954305,12 1,11.1045695 1,10 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"
			}),
			/* @__PURE__ */ _jsx("polyline", {
				stroke: "#E3E3E3",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2,
				points: "10 5 13 8 16 5",
				transform: "rotate(-180 13 6.5)"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(24 1)",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "#C8102E",
					d: "M0,0 L21,0 C22.1045695,-2.02906125e-16 23,0.8954305 23,2 L23,9 C23,10.1045695 22.1045695,11 21,11 L0,11 L0,11 L0,0 Z"
				}), /* @__PURE__ */ _jsx("polyline", {
					stroke: "#E3E3E3",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2,
					points: "9 4 12 7 15 4"
				})]
			})
		]
	})
});
export default SvgSub;
